import Button from 'components/shared/Button/Button';

const baseColumns = [
  {
    field: 'name',
    headerName: 'Name',
    flex: 1,
    valueGetter: (params) => {
      const provider = params.data;
      return provider?.type === 'billing'
        ? provider?.bill_name
        : provider?.fullName || provider?.label;
    }
  },
  {
    field: 'npi',
    headerName: 'NPI',
    valueGetter: (params) => {
      const provider = params.data;
      return provider?.type === 'billing' ? provider?.bill_npi : provider?.billingInfo?.npi || '-';
    }
  },
  {
    field: 'type',
    headerName: 'Type',
    valueGetter: (params) => {
      const provider = params.data;
      return provider?.type === 'billing' ? 'Billing provider' : 'Rendering provider';
    }
  }
];

export const getProviderColumns = (enableSelection, onRemove) => {
  if (onRemove && !enableSelection) {
    return [
      {
        maxWidth: 50,
        flex: 0,
        cellRenderer: (params) => {
          return (
            <Button
              variant="link"
              color="neutral"
              icon="close-mono"
              onClick={() => onRemove(params.data.id)}
            />
          );
        },
        sortable: false,
        filter: false,
        resizable: false
      },
      ...baseColumns
    ];
  }

  if (enableSelection) {
    return [
      {
        ...baseColumns[0],
        checkboxSelection: true,
        headerCheckboxSelection: true
      },
      ...baseColumns.slice(1)
    ];
  }

  return baseColumns;
};
